export const types = [
  { _id: 1, type: "New Arrival" },
  { _id: 2, type: "Best Seller" },
];
